module.exports = __webpack_public_path__ + "assets/img/image11.42355472.png";